import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http/http.service';
@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(private http: HttpService) { }

  user(){
    return this.http.query('get', 'user', {}, '');
  }

  email_verified(){
    return this.http.query('get', 'auth/resend-verify-email', {}, '');
  }
}
